import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { formatRoute } from 'react-router-named-routes';
import SpaceLandingPageContent from './space_landing_page_content';
import { PUBLIC_SPACE_LANDING_PAGE_ONBOARD_ROUTE } from '../../services/routes';
import { trackEvents } from '../../operations/tracking_operations';
import { DEFAULT_SMORG_BACKGROUND_COLOR } from '../../services/spaces';
import { useGetPublicSpaceQuery } from '../../app/smorgAppSyncGraphQLApi';
import ThemeChangeListener from '../common/theme_change_listener';
import { SPACE_REFRESH_INTERVAL_SECONDS } from '../../services/end_user_published_resources';
import { setEndUserDesiredSpaceID } from '../../features/white_label/white_label_slice';

const SpaceLandingPageMobile = () => {
  const { spaceId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (spaceId) {
      dispatch(setEndUserDesiredSpaceID(spaceId));
    }
  }, [dispatch, spaceId]);

  const { data: currentSpace } = useGetPublicSpaceQuery(spaceId, {
    skip: !spaceId,
    refetchOnMountOrArgChange: SPACE_REFRESH_INTERVAL_SECONDS,
  });

  return (
    <div className="landing-page-centering-wrapper">
      <ThemeChangeListener />
      <main
        className="landingPage"
        style={{
          width: '100%',
          height: 'var(--app-height)',
          backgroundColor:
            currentSpace?.landingPageStyle?.backgroundColor ||
            DEFAULT_SMORG_BACKGROUND_COLOR,
          display: 'flex',
          overflowY: 'auto',
        }}>
        <SpaceLandingPageContent
          showSignupControls
          onClickJoin={() => {
            trackEvents([
              { name: 'Clicked to join space', args: { space_id: spaceId } },
            ]);
            navigate({
              pathname: formatRoute(PUBLIC_SPACE_LANDING_PAGE_ONBOARD_ROUTE, {
                spaceId,
              }),
            });
          }}
        />
      </main>
    </div>
  );
};

export default SpaceLandingPageMobile;
